module.exports = __webpack_public_path__ + "media/click.284c590c.mp3";